<div class="flex align-items-center gap-2 flex-wrap">
  @if (tags && tags.length > 0) {
    @for (item of tags; track '_id') {
      <p-tag
        [rounded]="true"
        icon="fas fa-tag"
        [severity]="severity"
        [styleClass]="styleClass"
        [value]="item.title"></p-tag>
    }
  } @else {
    @for (tagId of tagIds; track tagId) {
      @if (tagStore.getById(tagId); as tag) {
        <p-tag
          [rounded]="true"
          icon="fas fa-tag"
          [severity]="severity"
          [styleClass]="styleClass"
          [value]="tag.title"></p-tag>
      }
    }
  }
</div>
